import template from './educationModal.html';
import controller from './educationModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    education: '<',
  },
};
